import React from 'react';
import { connect } from 'react-redux';

import * as authUserSelectors from '../../../../redux/auth/user/selectors';
import { requestPasswordReset } from '../../../../redux/auth/requestPasswordReset/actions';
import { selectLoading, selectError, selectErrorMessage } from '../../../../redux/auth/requestPasswordReset/selectors';

import ResetPasswordCard from './ResetPasswordCard';

const ResetPasswordCardConnected = (props) => <ResetPasswordCard {...props} />;

const mapActionsToProps = {
  requestPasswordReset,
};

const mapStateToProps = (state) => ({
  email: authUserSelectors.selectEmail(state),

  loading: selectLoading(state),
  error: selectError(state),
  errorMessage: selectErrorMessage(state),
});

export default connect(mapStateToProps, mapActionsToProps)(ResetPasswordCardConnected);
